/**
 * State for auth
 */
export const state = {
  /**
   * For auth loading screen
   */
  loadingAuth: false,

  /**
   * Username of the user
   */
  username: "",

  /**
   * User Id of the user
   */
  userId: 0,

  /**
   * Auth token of the user
   */
  token: "",

  /**
   * Error message if any to display to the user,
   */
  message: "",

  /**
   * Error message at the bottom
   */
  bottomMessage: "",

  /**
   * User role is for which features are available to the user
   */
  userRole: 0,

  /**
   * User type along with user role is for checking what permission the user has
   */
  userType: -1,

  /**
   * Additional check for app users to check if they have permissions to add, edit and delete
   */
  addionalPermissionToAddEditAndDelete: false,

  /**
   * Permission to add secure video appointment
   */
  add_video_appointment_permission: false,

  /**
   * No permission to delete video appointment
   */
  delete_video_appointment_permission_refused: true,

  /**
   * Variable to check if session details have already been updated in the state
   */
  fromLocal: false,

  /**
   * First name of the user
   */
  firstName: "",
  /**
   * Last name of the user
   */
  lastName: "",
  /**
   * Middle name of the user
   */
  middleName: "",
  /**
   *  Name prefix of the user
   */
  namePrefix: "",
  /**
   * Name suffix of the user
   */
  nameSuffix: "",
  /**
   * Credentials of the user
   */
  credentials: "",

  /**
   * Permitted provider who have given permission to the user
   *
   * Format
   * {
   *    // When both permission_id & permission_status is null, the user has permission to add/edit appointment
   *   permission_id: 12, // The permission id is related to weather the user has add/edit permission.
   *   permission_status: 21, // The permission status is also related to the add/edit permission.
   *   videoUserID: 134 // The video user id of the new provider if any
   *   add_video_appointment_permission: false, // Permission to add video appointment
   *    delete_video_appointment_permission_refused: false // If delete video appt permission is revoked
   * }[]
   *
   *
   */
  permittedUserList: [],

  /**
   * Currently selected provider ID
   */
  selectedProviderId: 0,

  /**
   * Weather the socket has been authorized of the user
   */
  socketAuthorized: false,

  /**
   * The next route to which the user should be taken after logging in
   */
  nextRoute: false,

  /**
   * When animating through a route
   */
  routeAnimating: false,

  /**
   * Timezone of logged in user
   */
  loggedInTimezone: "",

  /**
   * Weather to show the add to home screen popup
   */
  showAddToHomePopup: false,

  /**
   * Add to home event
   */
  addToHomeEvent: null,

  /**
   * Weather to show the notification popup
   */
  showNotificationPopup: false,

  /**
   * Email Tab Permission
   *
   * Format
   * {
   *   3159: "allowed",
   *   3187: "denied"
   * }
   */
  emailTabPermission: {},

  /**
   * Sets the user subscription
   */
  userSubscription: "",

  /**
   * Secure video user id
   */
  videoUserId: 0,

  /**
   * Connect video user id
   */
  connectUserId: 0
};
